/* NOJE - sticky ATC price hydration. */
(function () {
  if (window.__nojeStickyATCPrice) return;
  window.__nojeStickyATCPrice = true;

  function money(cents) {
    try { return (cents / 100).toLocaleString('en-EG', { maximumFractionDigits: 0 }) + ' EGP'; }
    catch (e) { return Math.round(cents / 100) + ' EGP'; }
  }

  var tries = 0;

  function run() {
    var bar = document.getElementById('noje-sticky-atc');
    if (!bar) { if (++tries < 60) setTimeout(run, 300); return; }

    var priceEl = bar.querySelector('.noje-satc__price');
    if (!priceEl) return;

    var idInput = null;
    var forms = [].slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    for (var i = 0; i < forms.length; i++) {
      var idi = forms[i].querySelector('[name="id"]');
      var btn = forms[i].querySelector('[name="add"], button[type="submit"], input[type="submit"]');
      if (idi && btn && forms[i].offsetParent !== null) { idInput = idi; break; }
    }
    if (!idInput) return;

    fetch(window.location.pathname.split('?')[0] + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || !p.variants) return;
        var map = {};
        p.variants.forEach(function (v) { map[String(v.id)] = v.price; });
        function paint() {
          var c = map[String(idInput.value)];
          priceEl.textContent = (c != null) ? money(c) : '';
        }
        paint();
        idInput.addEventListener('change', paint);
        setInterval(paint, 1200);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();